// Select all elements with the class 'swatch_button Size-button'
const buttons = document.querySelectorAll(
    "input.swatch_button.Size-button, input.swatch_button.color-swatch"
);
var inventoryThreshold = parseInt(
    window.PXUTheme.theme_settings.inventory_threshold
);
const product_count_one = window.PXUTheme.translation.product_count_other;
const product = JSON.parse(
    document.querySelector(".product_form").dataset["product"]
);

function initializeProductImages() {
    // Determine if the viewport is desktop
    const isDesktop = window.innerWidth > 768;

    // Get all selected swatch options
    const selectedOptions = Array.from(
        document.querySelectorAll(".swatch input:checked")
    ).map((input) => input.value);

    // Select the product gallery
    const gallery = document.querySelector(".product-gallery");

    // If gallery exists and we're on desktop, proceed with image filtering
    if (gallery && isDesktop) {
        if (selectedOptions.length > 0) {
            // Use the first selected option to filter images
            const option1 = selectedOptions[0];

            // Get all images in the gallery
            const allImages = gallery.querySelectorAll("img");

            // Hide all images
            allImages.forEach((img) => {
                img.style.display = "none";
            });

            // Show images matching the selected option or "All"
            const matchingImages = gallery.querySelectorAll(
                `img[alt="${option1}"], img[alt="All"]`
            );
            matchingImages.forEach((img) => {
                img.style.display = "block";
            });
        }
    } else if (gallery && !isDesktop) {
        // On mobile, show all images
        const allImages = gallery.querySelectorAll("img");
        allImages.forEach((img) => {
            img.style.display = "block";
        });
    }
}

// Event listener to handle changes in swatch selection and window resizing
function attachEventListeners() {
    // Reinitialize on swatch selection change
    document.querySelectorAll(".swatch input").forEach((input) => {
        input.addEventListener("change", initializeProductImages);
    });

    // Reinitialize on window resize to handle desktop/mobile behavior
    window.addEventListener("resize", initializeProductImages);
}

function initializeColorSwatches() {
    const availableOptions = product.variants
        .filter(v => v.available)
        .map(v => v.option1);
    const uniqueOptions = [...new Set(availableOptions)];

    // Update color swatches
    $(parent + ' .swatch[data-option-index="0"] .swatch-element').each(function () {
        if (uniqueOptions.includes($(this).attr("data-value"))) {
            $(this)
                .removeClass("soldout")
                .find(":radio")
                .prop("disabled", false);
        } else {
            $(this)
                .addClass("soldout")
                .find(":radio")
                .prop("disabled", true);
        }
    });

    // Get the selected color (option1)
    const selectedColor = $(parent + ' .swatch[data-option-index="0"] input:checked').val();

    // Find available sizes for the selected color
    const availableSizes = product.variants
        .filter(v => v.available && v.option1 === selectedColor)
        .map(v => v.option2);

    // Update size swatches
    $(parent + ' .swatch[data-option-index="1"] .swatch-element').each(function () {
        const sizeValue = $(this).attr("data-value");
        if (availableSizes.includes(sizeValue)) {
            $(this)
                .removeClass("soldout")
                .find(":radio")
                .prop("disabled", false);

            // Select the first available size if none is selected
            if (!$(parent + ' .swatch[data-option-index="1"] input:checked').length) {
                $(this).find(":radio").prop("checked", true);
            }
        } else {
            $(this)
                .addClass("soldout")
                .find(":radio")
                .prop("checked", false)
                .prop("disabled", true);
        }
    });

    // Prevent clicking soldout swatches
    $(parent + ' .swatch[data-option-index="1"] .swatch-element').off('click').on('click', function (e) {
        if ($(this).hasClass('soldout')) {
            e.preventDefault(); // Stop default behavior
            e.stopPropagation(); // Prevent event from bubbling up
            return false;
        }
    });

    // Additionally disable interaction with soldout radio buttons
    $(parent + ' .swatch[data-option-index="1"] .swatch-element.soldout input[type="radio"]').off('click').on('click', function (e) {
        e.preventDefault(); // Stop default behavior
        return false;
    });

    // Hide any size swatches flagged (via accentuate.hide_size) for the color
    // that's now selected. Runs last so it never gets overridden by the
    // soldout pass above.
    applyHideSizeForColor(selectedColor);
}

// Hide the size swatch for the currently selected color when that specific
// (color, size) variant has accentuate.hide_size = true. product__swatch.liquid
// bakes the list of colors that should hide a given size into that size
// swatch-element's data-hide-size-colors attribute; this only ever hides the
// size for the colors listed there, never for other colors or other sizes.
function applyHideSizeForColor(selectedColor) {
    if (!selectedColor) return;

    var hadCheckedHiddenSize = false;

    $(parent + ' .swatch[data-option-index="1"] .swatch-element').each(function () {
        var hideColorsRaw = $(this).attr("data-hide-size-colors") || "";
        var hideColors = hideColorsRaw
            .split(",")
            .map(function (c) { return c.trim(); })
            .filter(Boolean);
        var shouldHide = hideColors.indexOf(selectedColor) !== -1;
        var $radio = $(this).prev(':radio');

        if (shouldHide) {
            $(this).addClass("hide-size");
            $radio.prop("disabled", true);
            if ($radio.prop("checked")) {
                $radio.prop("checked", false);
                hadCheckedHiddenSize = true;
            }
        } else {
            $(this).removeClass("hide-size");
            if (!$(this).hasClass("soldout")) {
                $radio.prop("disabled", false);
            }
        }
    });

    // The size that was selected is hidden for this color - fall back to the
    // first visible, in-stock size so a color change never leaves nothing selected.
    if (hadCheckedHiddenSize) {
        var $fallback = $(parent + ' .swatch[data-option-index="1"] .swatch-element')
            .not(".hide-size")
            .not(".soldout")
            .first();
        if ($fallback.length) {
            var fallbackRadio = $fallback.prev(':radio')[0];
            if (fallbackRadio) {
                fallbackRadio.checked = true;
                fallbackRadio.dispatchEvent(new Event("change", { bubbles: true }));
            }
        }
    }
}

// Grey out / disable every swatch that has no available variant for the
// options selected before it (Color -> Neck -> Sleeve).
function updateSwatchAvailability() {
    var form = document.querySelector(".product_form form");
    if (!form) return;

    var groups = Array.from(
        form.querySelectorAll(".swatch[data-option-index]")
    ).sort(function (a, b) {
        return Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex);
    });

    var selected = groups.map(function (group) {
        var checked = group.querySelector("input:checked");
        return checked ? checked.value : "";
    });

    groups.forEach(function (group, index) {
        group.querySelectorAll(".swatch-element").forEach(function (el) {
            var value = el.getAttribute("data-value");
            var radio = el.querySelector("input[type='radio']") || el.previousElementSibling;

            // Available only if a purchasable variant exists with this value
            // AND the same values for all earlier options.
            var isAvailable = product.variants.some(function (v) {
                if (!v.available || v.options[index] !== value) return false;
                for (var i = 0; i < index; i++) {
                    if (v.options[i] !== selected[i]) return false;
                }
                return true;
            });

            el.classList.toggle("soldout", !isAvailable);

            if (radio) {
                // keep swatches hidden by accentuate.hide_size disabled
                radio.disabled = !isAvailable || el.classList.contains("hide-size");
                if (!isAvailable && radio.checked) radio.checked = false;
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", () => {
    const initializeAll = () => {
        handleUrlVariant();
        initializeProductImages();
        attachEventListeners();

        // Add this new function call first
        selectFirstAvailableSize();
        initializeProductText();
        initializeColorSwatches();
        setTimeout(updateSwatchAvailability, 200); // after selectVariant's 100ms timeout
    };

    function handleUrlVariant() {
        const url = new URL(window.location.href);
        const variantId = url.searchParams.get("variant");

        if (variantId) {
            // Handle case where variant ID is in URL
            const variant = product.variants.find(v => v.id.toString() === variantId);
            if (variant) {
                selectVariant(variant, true); // Pass true to indicate this is from URL
            } else {
                selectDefaultVariant();
            }
        } else {
            // No variant in URL - select first available variant
            selectDefaultVariant();
        }
    }

    function selectDefaultVariant() {
        // Find first available variant
        const firstAvailableVariant = product.variants.find(v => v.available);

        if (firstAvailableVariant) {
            // Update URL with the default variant
            const url = new URL(window.location.href);
            url.searchParams.set("variant", firstAvailableVariant.id);
            window.history.replaceState({}, "", url);

            selectVariant(firstAvailableVariant);
        }
    }

    function selectVariant(variant, fromUrl = false) {
        // Set color (option1)
        const colorInput = document.querySelector(
            `${parent} .swatch[data-option-index="0"] input[value="${variant.option1}"]`
        );
        if (colorInput) {
            colorInput.checked = true;
            colorInput.dispatchEvent(new Event('change'));
        }

        // Wait for color change to process before setting size
        setTimeout(() => {
            // Set size (option2)
            const sizeInput = document.querySelector(
                `${parent} .swatch[data-option-index="1"] input[value="${variant.option2}"]`
            );
            if (sizeInput) {
                sizeInput.checked = true;
                sizeInput.dispatchEvent(new Event('change'));
            } else if (!fromUrl) {
                // Only select first available size if not loading from URL
                selectFirstAvailableSize();
            }

            // If there's a third option (e.g., inseam), set it
            if (variant.option3) {
                const option3Input = document.querySelector(
                    `${parent} .swatch[data-option-index="2"] input[value="${variant.option3}"]`
                );
                if (option3Input) {
                    option3Input.checked = true;
                    option3Input.dispatchEvent(new Event('change'));
                }
            }
        }, 100);
    }

    function selectFirstAvailableSize() {
        const selectedColor = document.querySelector(
            `${parent} .swatch[data-option-index="0"] input:checked`
        )?.value;

        if (selectedColor) {
            const availableSizes = product.variants
                .filter(v => v.available && v.option1 === selectedColor)
                .map(v => v.option2);

            if (availableSizes.length > 0) {
                // First uncheck all sizes
                document.querySelectorAll(`${parent} .swatch[data-option-index="1"] input`).forEach(input => {
                    input.checked = false;
                });

                // Find and select first available size
                const firstAvailableSize = document.querySelector(
                    `${parent} .swatch[data-option-index="1"] input[value="${availableSizes[0]}"]`
                );
                if (firstAvailableSize) {
                    firstAvailableSize.checked = true;
                    firstAvailableSize.dispatchEvent(new Event('change'));

                    // Update URL with the new variant
                    const newVariant = product.variants.find(
                        v => v.available && v.option1 === selectedColor && v.option2 === availableSizes[0]
                    );
                    if (newVariant) {
                        const url = new URL(window.location.href);
                        url.searchParams.set("variant", newVariant.id);
                        window.history.replaceState({}, "", url);
                    }
                }
            }
        }
    }

    function initializeProductText() {
        const selectedVariant = product.variants.find(
            (item) => item.id.toString() === selectedVariantId
        );

        if (selectedVariant) {
            // Update color text
            const colortextElement = document.getElementById("colortext");
            if (colortextElement && selectedVariant.option1) {
                colortextElement.innerHTML = selectedVariant.option1;
            }

            // Update size text
            const sizeElement = document.getElementById("sizetext");
            const waistElement = document.getElementById("waisttext");
            if (sizeElement && selectedVariant.option2) {
                sizeElement.innerHTML = selectedVariant.option2;
            } else if (waistElement && selectedVariant.option2) {
                waistElement.innerHTML = selectedVariant.option2;
            }

            // Update inseam text
            const inseamElement = document.getElementById("inseamtext");
            if (inseamElement && selectedVariant.option3) {
                inseamElement.innerHTML = selectedVariant.option3;
            }
        }
    }


    // New function to select first available size
    function selectFirstAvailableSize() {
        const selectedColor = $(parent + ' .swatch[data-option-index="0"] input:checked').val();
        if (selectedColor) {
            // Find first available size for the selected color
            const sizeElements = $(parent + ' .swatch[data-option-index="1"] .swatch-element');
            let firstAvailableFound = false;

            // First uncheck all sizes
            sizeElements.find(':radio').prop('checked', false);

            // Then find and select first available size
            sizeElements.each(function () {
                if (!firstAvailableFound && !$(this).hasClass('soldout')) {
                    $(this).find(':radio')
                        .prop('checked', true)
                        .trigger('change');
                    firstAvailableFound = true;
                }
            });

            // If no available size was found, select the first size regardless
            if (!firstAvailableFound && sizeElements.length > 0) {
                sizeElements.first().find(':radio')
                    .prop('checked', true)
                    .trigger('change');
            }
        }
    }

    // Initial load with multiple attempts
    setTimeout(initializeAll, 100);  // Quick first attempt

    window.addEventListener('load', () => {
        setTimeout(initializeAll, 500);  // Backup attempt after full page load
    });
});


// Pre-order update
const $product = $(".product-" + product.id);
const shipDate =
    document.querySelector(".product_form form").parentElement.dataset.shipDate;

// Inventory update
const qty = JSON.parse(
    document.querySelector(".product_form").dataset["variantInventory"]
);
const url = new URL(window.location.href);
const variantValue = url.searchParams.get("variant");
const selectedVariantId =
    document.querySelector(".product_form").dataset["selectedVariant"];
const selectedVariant = product.variants.find(
    (item) => item.id == selectedVariantId
);
var onLoadSoldOut =
    product.variants.filter(
        (variant) => !variant.available && variant.id == variantValue
    ).length > 0
        ? true
        : false;
// Building our mapping object. For Size Avaliable and soldout Update
optionsMap = {};

for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];

    if (variant.available) {
        // Gathering values for the 1st drop-down.
        optionsMap["root"] = optionsMap["root"] || [];
        optionsMap["root"].push(variant.option1);
        optionsMap["root"] = Shopify.uniq(optionsMap["root"]); // Gathering values for the 2nd drop-down.

        if (product.options.length > 1) {
            var key2 = variant.option1;
            optionsMap[key2] = optionsMap[key2] || [];
            optionsMap[key2].push(variant.option2);
            optionsMap[key2] = Shopify.uniq(optionsMap[key2]);
        } // Gathering values for the 3rd drop-down.

        if (product.options.length === 3) {
            var key2 = variant.option1 + " / " + variant.option2;
            optionsMap[key2] = optionsMap[key2] || [];
            optionsMap[key2].push(variant.option3);
            optionsMap[key2] = Shopify.uniq(optionsMap[key2]);
        }
    }
}
const parent = ".product-" + product.id + " .js-product_section";
var key3 = null;
var key4 = null;
const parentElement = document.querySelector(".select-container"); // Replace `parent` with your actual parent selector

const observer2 = new MutationObserver(function (mutationsList, observer) {
    key3 = $(parent + " .single-option-selector:eq(0)").val();
    key4 = $(parent + " .single-option-selector:eq(1)").val();

    function updateSwatchElements(key, optionIndex) {
        if (key || optionIndex === 0) {
            var availableOptions;
            if (optionIndex === 0) {
                availableOptions = optionsMap["root"] || product.variants
                    .filter(v => v.available)
                    .map(v => v.option1)
                    .filter((v, i, a) => a.indexOf(v) === i);
            } else {
                availableOptions = optionsMap[optionIndex == 1 ? key3 : key3 + " / " + key4];
            }

            if (availableOptions) {
                var sizeChecked = false;
                let firstAvailableOption = null;

                // First pass: mark available/soldout status and find first available option
                $(parent + ' .swatch[data-option-index="' + optionIndex + '"] .swatch-element').each(function () {
                    const isAvailable = $.inArray($(this).attr("data-value"), availableOptions) !== -1;

                    if (isAvailable) {
                        $(this)
                            .removeClass("soldout")
                            .find(":radio")
                            .removeAttr("disabled", "disabled");

                        // Store first available option
                        if (!firstAvailableOption) {
                            firstAvailableOption = this;
                        }
                    } else {
                        $(this)
                            .addClass("soldout")
                            .find(":radio")
                            .removeAttr("checked")
                            .attr("disabled", "disabled");

                        // Uncheck if it's sold out
                        this.previousElementSibling.checked = false;
                    }
                });

                // Second pass: handle selection
                $(parent + ' .swatch[data-option-index="' + optionIndex + '"] .swatch-element').each(function () {
                    const isAvailable = $.inArray($(this).attr("data-value"), availableOptions) !== -1;

                    if (isAvailable) {
                        // If this matches the selected variant, select it
                        if (selectedVariant && selectedVariant.options[optionIndex] === this.dataset.value) {
                            this.previousElementSibling.checked = true;
                            sizeChecked = true;
                        }
                    }
                });

                // If no size is checked yet, select the first available option
                if (!sizeChecked && firstAvailableOption) {
                    firstAvailableOption.previousElementSibling.checked = true;
                    sizeChecked = true;

                    // Update URL if needed
                    if (!onLoadSoldOut) {
                        var urlTemp = new URL(window.location.href);
                        urlTemp.searchParams.set(
                            "variant",
                            optionIndex === 0
                                ? firstAvailableOption.previousElementSibling.dataset["availableVariant"]
                                : selectedVariantId
                        );
                        window.history.replaceState({}, "", urlTemp);
                    }
                }
            }
        }
    }

    // Always update option 0 first
    updateSwatchElements(null, 0);
    setTimeout(() => {
        updateSwatchElements(key3, 1);
        updateSwatchElements(key4, 2);
    }, 50);

    if (key3 || key4) {
        if (onLoadSoldOut) {
            var message = window.PXUTheme.translation.soldOut;
            $(".was-price", $product).text("");
            $(".savings", $product).text("");
            $(".preorder-date__wrapper").text(" ");
            $(".current_price", $product).text("");
            $(".items_left", $product).text("");
            $("[data-max-inventory-management]", $product).removeAttr("max");
            $(".sold_out", $product).text(message);
            $("[data-add-to-cart-trigger]", $product)
                .addClass("disabled")
                .attr("disabled", "disabled")
                .find("span:not(.icon)")
                .text(message);
            $(".shopify-payment-button", $product).hide();
            $(".purchase-details__quantity", $product).hide();
            onLoadSoldOut = false;
        }
        initializeProductImages();
        observer2.disconnect();
    }
});

observer2.observe(parentElement, { childList: true, subtree: true });

// Function to handle the event
// Resolve the selected variant from the actual checked option values.
// IMPORTANT:
// Do NOT use event.target.dataset.variant here.
// data-variant represents the first variant rendered for an option value,
// which can be the wrong combination for 3-option products.
//
// Dress Shirts:
// Color / Neck Size / Sleeve
//
// Pants:
// Color / Waist / Inseam

function handleButtonChange(event) {
    if (!event || !event.target || !event.target.checked) {
        return;
    }

    const input = event.target;
    const form = input.closest(".product_form form");

    if (!form) {
        return;
    }

    const groups = Array.from(
        form.querySelectorAll(".swatch[data-option-index]")
    ).sort(function (a, b) {
        return (
            Number(a.dataset.optionIndex) -
            Number(b.dataset.optionIndex)
        );
    });

    const optionCount = product.options.length;

    /*
     * ---------------------------------------------------------
     * Get currently selected values
     * ---------------------------------------------------------
     */
    let selectedOptions = groups.map(function (group) {
        const checked = group.querySelector("input:checked");
        return checked ? checked.value : "";
    });

    /*
     * ---------------------------------------------------------
     * OPTION 1 / COLOR CHANGED
     *
     * When Color changes, the old Neck/Sleeve combination may
     * no longer be valid.
     *
     * We therefore resolve the dependent options first.
     * ---------------------------------------------------------
     */
    if (Number(input.closest(".swatch").dataset.optionIndex) === 0) {

        const color = selectedOptions[0];

        if (!color) {
            return;
        }

        /*
         * Find all available variants for this color.
         */
        const colorVariants = product.variants.filter(function (variant) {
            return (
                variant.available &&
                variant.option1 === color
            );
        });

        if (!colorVariants.length) {
            return;
        }

        /*
         * Try to preserve the currently selected Neck + Sleeve.
         */
        let matchingVariant = colorVariants.find(function (variant) {
            return (
                variant.option2 === selectedOptions[1] &&
                (
                    optionCount < 3 ||
                    variant.option3 === selectedOptions[2]
                )
            );
        });

        /*
         * If the complete combination does not exist,
         * try to preserve Neck Size and find the first
         * available Sleeve.
         */
        if (!matchingVariant && optionCount >= 2) {

            matchingVariant = colorVariants.find(function (variant) {
                return variant.option2 === selectedOptions[1];
            });
        }

        /*
         * If Neck Size is also unavailable for this color,
         * use the first available variant for the color.
         */
        if (!matchingVariant) {
            matchingVariant = colorVariants[0];
        }

        /*
         * -----------------------------------------------------
         * Set exact Neck Size
         * -----------------------------------------------------
         */
        if (optionCount >= 2 && matchingVariant.option2) {

            const neckInput = Array.from(
                groups[1].querySelectorAll("input")
            ).find(function (radio) {
                return radio.value === matchingVariant.option2;
            });

            if (neckInput) {
                neckInput.checked = true;
            }
        }

        /*
         * -----------------------------------------------------
         * Set exact Sleeve
         * -----------------------------------------------------
         */
        if (optionCount >= 3 && matchingVariant.option3) {

            const sleeveInput = Array.from(
                groups[2].querySelectorAll("input")
            ).find(function (radio) {
                return radio.value === matchingVariant.option3;
            });

            if (sleeveInput) {
                sleeveInput.checked = true;
            }
        }

        /*
         * Re-read selected options after correcting
         * dependent options.
         */
        selectedOptions = groups.map(function (group) {
            const checked = group.querySelector("input:checked");
            return checked ? checked.value : "";
        });
    }

    /*
     * ---------------------------------------------------------
     * OPTION 2 / NECK SIZE CHANGED
     *
     * Find a valid Sleeve for the selected
     * Color + Neck combination.
     * ---------------------------------------------------------
     */
    if (Number(input.closest(".swatch").dataset.optionIndex) === 1) {

        const color = selectedOptions[0];
        const neck = selectedOptions[1];

        if (!color || !neck) {
            return;
        }

        const neckVariants = product.variants.filter(function (variant) {
            return (
                variant.available &&
                variant.option1 === color &&
                variant.option2 === neck
            );
        });

        if (!neckVariants.length) {
            return;
        }

        /*
         * Try to preserve currently selected Sleeve.
         */
        let matchingVariant = neckVariants.find(function (variant) {
            return (
                optionCount < 3 ||
                variant.option3 === selectedOptions[2]
            );
        });

        /*
         * If current Sleeve isn't available,
         * use the first available Sleeve.
         */
        if (!matchingVariant) {
            matchingVariant = neckVariants[0];
        }

        /*
         * Update Sleeve.
         */
        if (optionCount >= 3 && matchingVariant.option3) {

            const sleeveInput = Array.from(
                groups[2].querySelectorAll("input")
            ).find(function (radio) {
                return radio.value === matchingVariant.option3;
            });

            if (sleeveInput) {
                sleeveInput.checked = true;
            }
        }

        /*
         * Re-read selected options.
         */
        selectedOptions = groups.map(function (group) {
            const checked = group.querySelector("input:checked");
            return checked ? checked.value : "";
        });
    }

    /*
     * ---------------------------------------------------------
     * OPTION 3 / SLEEVE CHANGED
     * ---------------------------------------------------------
     */
    if (Number(input.closest(".swatch").dataset.optionIndex) === 2) {

        selectedOptions = groups.map(function (group) {
            const checked = group.querySelector("input:checked");
            return checked ? checked.value : "";
        });
    }

    /*
     * ---------------------------------------------------------
     * Find EXACT variant
     * ---------------------------------------------------------
     */
    const variant = product.variants.find(function (candidate) {

        if (!candidate.available) {
            return false;
        }

        return candidate.options
            .slice(0, optionCount)
            .every(function (value, index) {
                return value === selectedOptions[index];
            });
    });

    /*
     * Safety check.
     */
    if (!variant) {
        console.warn(
            "No available variant found:",
            selectedOptions
        );

        $("[data-add-to-cart-trigger]", $product)
            .addClass("disabled")
            .attr("disabled", "disabled");

        return;
    }

    /*
     * ---------------------------------------------------------
     * Make sure swatches exactly match the variant.
     * ---------------------------------------------------------
     */
    variant.options
        .slice(0, optionCount)
        .forEach(function (value, index) {

            if (!groups[index]) {
                return;
            }

            const radio = Array.from(
                groups[index].querySelectorAll("input")
            ).find(function (input) {
                return input.value === value;
            });

            if (radio) {
                radio.checked = true;
            }
        });

        updateSwatchAvailability();

    /*
     * ---------------------------------------------------------
     * Update Color text
     * ---------------------------------------------------------
     */
    const colorText = document.getElementById("colortext");

    if (colorText) {
        colorText.innerHTML = variant.option1 || "";
    }

    /*
     * ---------------------------------------------------------
     * Update Neck / Waist text
     * ---------------------------------------------------------
     */
    const sizeText = document.getElementById("sizetext");
    const waistText = document.getElementById("waisttext");

    if (variant.option2) {

        if (sizeText) {
            sizeText.innerHTML = variant.option2;
        }

        if (waistText) {
            waistText.innerHTML = variant.option2;
        }
    }

    /*
     * ---------------------------------------------------------
     * Update Sleeve / Inseam text
     * ---------------------------------------------------------
     */
    const inseamText = document.getElementById("inseamtext");

    if (inseamText && variant.option3) {
        inseamText.innerHTML = variant.option3;
    }

    /*
     * ---------------------------------------------------------
     * Update Gallery
     * ---------------------------------------------------------
     */
    const gallery = document.querySelector(".product-gallery");

    if (gallery) {

        const images = gallery.querySelectorAll("img");

        if (window.innerWidth > 768) {

            images.forEach(function (img) {

                img.style.display =
                    img.alt === variant.option1 ||
                    img.alt === "All"
                        ? "block"
                        : "none";
            });

        } else {

            images.forEach(function (img) {
                img.style.display = "block";
            });
        }
    }

    /*
     * ---------------------------------------------------------
     * SKU
     * ---------------------------------------------------------
     */
    const skuElement =
        document.getElementsByClassName("sku")[0];

    if (skuElement) {
        skuElement.innerHTML = variant.sku || "";
    }

    /*
     * ---------------------------------------------------------
     * URL
     * ---------------------------------------------------------
     */
    const url = new URL(window.location.href);

    url.searchParams.set(
        "variant",
        variant.id
    );

    window.history.replaceState(
        {},
        "",
        url
    );

    /*
     * ---------------------------------------------------------
     * Price
     * ---------------------------------------------------------
     */
    const priceElement =
        document.getElementsByClassName("current_price")[0];

    if (priceElement) {

        if (variant.price > 0) {

            priceElement.innerHTML =
                '<span class="money">' +
                Shopify.formatMoney(
                    variant.price,
                    $("body").data("money-format")
                ) +
                "</span>";

        } else {

            priceElement.innerHTML =
                window.PXUTheme.translation
                    .free_price_text;
        }
    }

    /*
     * ---------------------------------------------------------
     * Hidden Shopify variant selector
     * ---------------------------------------------------------
     */
    const productSelect =
        document.getElementById(
            "product-select-" + product.id
        );

    if (productSelect) {

        productSelect.value =
            String(variant.id);

        Array.from(
            productSelect.children
        ).forEach(function (item) {

            item.selected =
                item.value === String(variant.id);
        });

        productSelect.dispatchEvent(
            new Event("change", {
                bubbles: true
            })
        );
    }

    /*
     * ---------------------------------------------------------
     * Inventory
     * ---------------------------------------------------------
     */
    const inventoryItem = qty.find(function (item) {
        return item.id === variant.id;
    });

    const inventoryQuantity =
        inventoryItem
            ? inventoryItem.inventory_quantity
            : 0;

    const quantityInput =
        document.querySelector(
            ".has-quantity-box .quantity-input"
        );

    if (quantityInput) {
        quantityInput.max = inventoryQuantity;
    }

    /*
     * ---------------------------------------------------------
     * Enable Add To Cart
     * ---------------------------------------------------------
     */
    if (variant.available) {

        $("[data-add-to-cart-trigger]", $product)
            .removeClass("disabled")
            .removeAttr("disabled")
            .find("span:not(.icon)")
            .text(
                $("[data-add-to-cart-trigger]", $product)
                    .data("label")
            );

        $(".shopify-payment-button", $product).show();

        $(".purchase-details__quantity", $product).show();
    }
}

// Add event listeners to each button
$(document).off(
    "change.variantSelector",
    ".product_form .swatch input[type='radio']"
);

$(document).on(
    "change.variantSelector",
    ".product_form .swatch input[type='radio']",
    function (event) {
        handleButtonChange(event);
    }
);
// Product "Gift Card" ID:7466982670558
if (product.id == 7466982670558) {
    // Create a MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver((mutationsList, observer) => {
        mutationsList.forEach((mutation) => {
            if (mutation.type === "childList") {
                // Check if the specific element is added
                const productSelectElement = document.getElementById(
                    "product-select-" + product.id + "-option-0"
                );
                if (productSelectElement) {
                    // Attach the event listener
                    productSelectElement.addEventListener("change", function (event) {
                        document.querySelector(".current_price .money").innerHTML =
                            event.target.selectedOptions[0].innerHTML;
                    });
                    // Once the element is found and event listener is attached, disconnect the observer
                    observer.disconnect();
                }
            }
        });
    });

    // Start observing the document body for added nodes
    observer.observe(document.body, { childList: true, subtree: true });
}

updateOptionsInSelector = function (selectorIndex, parent) {
    switch (selectorIndex) {
        case 0:
            var key = "root";
            var selector = $(parent + " .single-option-selector:eq(0)");
            break;

        case 1:
            var key = $(parent + " .single-option-selector:eq(0)").val();
            var selector = $(parent + " .single-option-selector:eq(1)");
            break;

        case 2:
            var key = $(parent + " .single-option-selector:eq(0)").val();
            key += " / " + $(parent + " .single-option-selector:eq(1)").val();
            var selector = $(parent + " .single-option-selector:eq(2)");
    }

    var availableOptions =
        optionsMap[key] ||
        optionsMap[
        key.split(" / ")[0] + " / " + optionsMap[key.split(" / ")[0]]
        ];
    $(
        parent +
        ' .swatch[data-option-index="' +
        selectorIndex +
        '"] .swatch-element'
    ).each(function () {
        if ($.inArray($(this).attr("data-value"), availableOptions) !== -1) {
            $(this)
                .removeClass("soldout")
                .find(":radio")
                .removeAttr("disabled", "disabled")
                .removeAttr("checked");
        } else {
            $(this)
                .addClass("soldout")
                .find(":radio")
                .removeAttr("checked")
                .attr("disabled", "disabled");
        }
    });
};

// Create a MutationObserver to watch for changes in the DOM
const observer34 = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
        if (mutation.type === "childList") {
            // Check if the specific element is added
            const productSelectElement = document.getElementById(
                "product-select-" + product.id + "-option-0"
            );
            if (productSelectElement) {
                // Attach the event listener
                productSelectElement.addEventListener("change", function (event) {
                    document.querySelector(".current_price .money").innerHTML =
                        event.target.selectedOptions[0].innerHTML;
                });
                // Once the element is found and event listener is attached, disconnect the observer
                observer34.disconnect();
            }
        }
    });
});

// Start observing the document body for added nodes
observer34.observe(document.body, { childList: true, subtree: true });